jQuery(document).ready(function ($) {
  var animeSpd = 400;
  var spflag = true;
  $('.parts-accordion-title-inner').each(function (i, e) {
    if (!$(this).hasClass('is-ative')) {
      $(this).parent().next().hide();
    }
  });
  $('.parts-accordion-title-inner').on('click', function () {
    $(this).toggleClass('is-active');
    $(this).parent().next().stop().slideToggle(400);
    $('.parts-parts-slick').slick('setPosition');
  });

  if ($('.js-slick')[0]) {
    secondarySlickSet();
  }

  var mediaQuery = matchMedia('(min-width: 768px)');
  // ページが読み込まれた時に実行
  // ウィンドウサイズが変更されても実行されるように
  mediaQuery.addListener(handle);

  function handle (mq) {
    if (mq.matches) {
    }else {
      if ($('.js-slick')[0]) {
        secondarySlickSet();
      }
    }
  }

  function secondarySlickSet () {
    $('.js-slick').slick({
      dots: false,
      speed: animeSpd,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [{
        breakpoint: 2000,
        settings: 'unslick'
      },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '10%'
          }
        }
      ],
      prevArrow: '<div class="u-product-slide-arrow u-product-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 29"><defs><clipPath id="a"><path data-name="" transform="translate(-.142 -.142)" d="M0 0h16v29H0z"/></clipPath></defs><g data-name="" transform="rotate(180 7.929 14.429)" clip-path="url(#a)"><path data-name="" d="M14.885 26.787l-.994.994L0 13.89 13.89 0l.995.994L1.99 13.891l12.896 12.895z"/></g></svg></div>',
      nextArrow: '<div class="u-product-slide-arrow u-product-next-arrow"><svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 29"><defs><clipPath id="a"><path data-name="" transform="translate(-.142 -.142)" d="M0 0h16v29H0z"/></clipPath></defs><g data-name="" transform="rotate(180 7.929 14.429)" clip-path="url(#a)"><path data-name="" d="M14.885 26.787l-.994.994L0 13.89 13.89 0l.995.994L1.99 13.891l12.896 12.895z"/></g></svg></div>'
    });
  }
});
